export default __webpack_public_path__ + "static/media/logo.3a3b6791.svg";